import { useEffect } from 'react';
import { getUserType, useSession } from '@distribusion/portal-lib/auth';
import * as Sentry from '@sentry/react';

export const useSetSentryUser = () => {
  const { isSuccess, data: session } = useSession();

  useEffect(() => {
    if (isSuccess) {
      const user = {
        email: session.identity?.traits?.email,
        type: getUserType(session),
      };
      Sentry.setUser(user);
      return () => Sentry.setUser(null);
    }
  }, [isSuccess, session]);
};
